import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { theme } from './styles/theme';
import { AuthProvider } from './hooks/useAuth';
import { OfflineProvider } from './hooks/useOfflineSync';
import { AppRoutes } from './components/AppRoutes';
import { Platform } from './platform/platform.detect';
import { NativePushInitializer } from './modules/notifications/NativePushInitializer';
import { DeepLinkHandler } from './modules/notifications/DeepLinkHandler';

// AIDEV-NOTE: QueryClient configurado para offline-first
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutos
      retry: 3,
      refetchOnWindowFocus: false // Controlado manualmente para offline
    }
  }
});

function App() {
  // AIDEV-NOTE: Inicializa StatusBar e SplashScreen em plataformas nativas
  useEffect(() => {
    if (Platform.isNative()) {
      StatusBar.setStyle({ style: Style.Default });
      StatusBar.setBackgroundColor({ color: '#1976d2' }).catch(() => {
        // AIDEV-NOTE: setBackgroundColor nao suportado no iOS, ignorar erro
      });
      // Esconde splash apos carregamento inicial
      SplashScreen.hide();
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AuthProvider>
            <OfflineProvider>
              {/* AIDEV-NOTE: Push nativo e deep links — componentes sem UI, ativos apenas em Capacitor */}
              <NativePushInitializer />
              <DeepLinkHandler />
              <AppRoutes />
            </OfflineProvider>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
